import Vue from 'vue';
import Vuebar from 'vuebar';
import VueCompositionApi, { provide } from '@vue/composition-api';
import { DefaultApolloClient } from '@vue/apollo-composable';
// import { plugin } from 'vivat';
import { plugin } from 'vivat';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
// import store from './store';
import { client } from './vue-apollo';

Vue.use(plugin);

Vue.use(VueCompositionApi);
Vue.use(Vuebar);

Vue.component('CommonModalWithPreset', CommonModalWithPreset);

(window as any).BUILD_NOTE = `${process.env.VUE_APP_BUILD_NOTE || 'HMR'}${(window as any).VIVAT_BUILD_NOTE || ''}`;
console.log('Build:', (window as any).BUILD_NOTE);

Vue.config.productionTip = false;

window.Vue = Vue;

new Vue({
  setup() {
    provide(DefaultApolloClient, client);
    return {};
  },
  router,
  // store,
  render: (h) => h(App),
}).$mount('#app');
